enum PacksOwnership {
  All = 0,
  Own = 1,
  Available = 2,
}

export default PacksOwnership;
